// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/* eslint-disable */
import React from 'react'
import { Menu } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import {
  isAdmin,
  isAuthenticated
} from 'services/self'

// mobx
import { observer } from 'mobx-react'

// fragments
import { fragments } from 'services/get-fragments'

// components
import { store } from 'services/state'

import "./style.css"

export const NavBar = observer(
  class NavBar extends React.Component {
    render () {
      const email = store.user && store.user.email
      return (
        <div className='nav-bar-container'>
          <div className='nav-bar-icon'>
            <Link to='/'>
              <div className="nav-bar-logo">
                  <img src="/custom-content/home-image.png"/>
              </div>
            </Link>
          </div>
          <div className='nav-bar-left'>
            <ul className="nav">
              <li><Menu.Item as={Link} to="/dashboard" name={"Dashboard"} /></li>
            </ul>
          </div>
          <div className='nav-bar-right'>
            <ul className="nav">
              {isAuthenticated() && (
                <>
                  {email && <li><Menu.Item>{email}</Menu.Item></li>}
                  {isAdmin() && <li><Menu.Item as={Link} to='/admin' name='Admin Panel' /></li>}
                </>
              )}
            </ul>
          </div>
        </div>
      )
    }
  }
)

export default NavBar
